/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { SkipBack, SkipForward } from 'lucide-react';
import { forwardRef, memo, useImperativeHandle, useRef } from 'react';
import './KeyAction.css';

export interface KeyActionHandle {
    rewind: HTMLDivElement;
    skip: HTMLDivElement;
}

interface KeyActionProps {
    on: boolean;
}

const KeyAction = forwardRef<KeyActionHandle, KeyActionProps>(({ on }, ref) => {
    const rewindRef = useRef<HTMLDivElement>(null);
    const skipRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => ({
        get rewind() {
            return rewindRef.current!;
        },
        get skip() {
            return skipRef.current!;
        },
    }));

    return (
        <div className="vp-key-action">
            <div className="vp-key-action__progress rewind" ref={rewindRef}>
                <div className="vp-key-action__progress__container">
                    <SkipBack />
                    <span>- 10 seconds</span>
                </div>
            </div>
            <div className="vp-key-action__progress skip" ref={skipRef}>
                <div className="vp-key-action__progress__container">
                    <SkipForward />
                    <span>+ 10 seconds</span>
                </div>
            </div>
        </div>
    );
});

export default memo(KeyAction);
